<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="settings">
    <v-row class="max-w">
      <v-col>
        <div class="display-1 font-weight-medium px-4">
          {{ $t('Ustawienia') }}
        </div>
        <v-list
          two-line
          flat
          class="transparent"
          max-width="540"
        >
          <v-list-item-group
            multiple
          >
            <v-list-item v-if="!pushSupported">
                <v-list-item-icon>
                  <v-icon>mdi-bell-ring</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('Powiadomienia') }}</v-list-item-title>
                  <v-list-item-subtitle>{{ $t('pow-brak-obslugi') }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch disabled></v-switch>
                </v-list-item-action>
            </v-list-item>
            <v-list-item v-else-if="notificationsStatus === 'denied'">
                <v-list-item-icon>
                  <v-icon>mdi-bell-ring</v-icon>
                </v-list-item-icon>
                <v-list-item-content @click="notificationsDeniedInfo">
                  <v-list-item-title>{{ $t('Powiadomienia') }}</v-list-item-title>
                  <v-list-item-subtitle>{{ $t(notificationDescr) }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch disabled></v-switch>
                </v-list-item-action>
            </v-list-item>
            <v-list-item v-else>
                <v-list-item-icon>
                  <v-icon>mdi-bell-ring</v-icon>
                </v-list-item-icon>
                <v-list-item-content @click="onChangeNotifications">
                  <v-list-item-title>{{ $t('Powiadomienia') }}</v-list-item-title>
                  <v-list-item-subtitle>{{ $t(notificationDescr) }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch :input-value="notifications" color="primary" @change="onChangeNotifications"></v-switch>
                </v-list-item-action>
            </v-list-item>
            

            <v-list-item to="/settings/lang">
              <v-list-item-icon>
                <v-icon>mdi-web</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('jezyk') }}</v-list-item-title>
                <v-list-item-subtitle class="text-uppercase">{{ lang }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-brightness-4</v-icon>
              </v-list-item-icon>
              <v-list-item-content @click="dark = !dark">
                <v-list-item-title>{{ $t('ciemny-m') }}</v-list-item-title>
                <v-list-item-subtitle>{{ $t('ciemny-op') }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch v-model="dark" color="primary"></v-switch>
              </v-list-item-action>
            </v-list-item>
            
            <!--<v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-home</v-icon>
              </v-list-item-icon>
              <v-list-item-content @click="homepage = !homepage">
                <v-list-item-title>{{ $t('rozpocznij') }}</v-list-item-title>
                <v-list-item-subtitle>{{ $t('rozpocznij-op') }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch v-model="homepage" color="primary"></v-switch>
              </v-list-item-action>
            </v-list-item>-->

          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col cols="12" offset="0">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12">
        <v-list
          one-line
          flat
          class="transparent"
          max-width="540"
        >
          <v-list-item-group
            multiple
          >
            <v-list-item to="/change-pass">
              <v-list-item-icon>
                <v-icon>mdi-lock</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('zmiana-hasla') }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data: () => ({
    notificationsStatus: 'testuje',
    notifications: false
  }),
  computed: {
    lang: {
      get: function() {
        return this.$i18n.locale
      },
      set: function(val) {
        this.setLang(val)
      }
    },
    notificationDescr() {
      return 'notif-' + this.notificationsStatus;
    },
    /*notificationsx: {
      get: function() {
        return (this.pushSupported) ? this.$store.state.user.notifications : false;
      },
      set: function(val) {
        this.setNotifications(val);
      }
    },*/
    dark: {
      get: function() {
        return this.$store.state.user.dark;
      },
      set: function(val) {
        this.setDark(val);
      }
    },
    /*homepage: {
      get: function() {
        return this.$store.state.user.homepage;
      },
      set: function(val) {
        this.setHomepage(val);
      }
    },*/
    pushSupported() {
      if (!('PushManager' in window)) {
        return false;
      } else {
        return true;
      }
    }
  },
  created () {
    this.getNotificationPermissionState()
    .then(res => {
      this.notificationsStatus = res;
      if (res === 'granted') {
        this.notifications = this.$store.state.user.notifi;
      } else {
        this.notifications = false;
      }
    });
  },
  methods: {
    ...mapActions([
      'setNotifi',
      'setDark',
      'setHomepage',
      'sendSubscriptionToServer'
    ]),
    notificationsDeniedInfo() {
      this.$store.commit("alert", {
        color: "error",
        text: 'notif-denied-info'
      });
    },
    onChangeNotifications() {
      if (this.notificationsStatus !== 'granted') {
        this.askPermission()
        .then(res => {
          if (res === 'granted') {
            this.subscribeUserToPush()
            .then(res => {
              this.sendSubscriptionToServer(res)
              .then(result => {
                if (result.ok) {
                  this.notificationsStatus = 'granted';
                  this.notifications = true;
                  this.setNotifi(true);
                } else {
                  this.notificationsStatus = 'granted';
                  this.notifications = false;
                  this.setNotifi(false);
                }
                return result;
              });
            });
          } else {
            this.notificationsStatus = res;
            this.notifications = (res === 'granted') ? true : false;
            this.setNotifi(this.notifications);
          }
        });
      } else {
        this.notifications = !this.notifications;
        this.setNotifi(this.notifications);
      }
    },
    askPermission() {
      return new Promise(function(resolve, reject) {
        const permissionResult = Notification.requestPermission(function(result) {
          resolve(result);
        });

        if (permissionResult) {
          permissionResult.then(resolve, reject);
        }
      })
      .then(function(permissionResult) {
        if (permissionResult !== 'granted') {
          throw new Error('We weren\'t granted permission.');
        } else {
          displayConfirmNotification();
          return permissionResult;
        }
      });
    },
    getNotificationPermissionState() {
      if (navigator.permissions) {
        return navigator.permissions.query({name: 'notifications'})
        .then((result) => {
          return result.state;
        });
      }

      return new Promise((resolve) => {
        resolve(Notification.permission);
      });
    },
    subscribeUserToPush() {
      //return navigator.serviceWorker.register('/service-worker.js')
      //.then(function(registration) {
      return navigator.serviceWorker.ready
      .then(registration => {
        const subscribeOptions = {
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(
            'BA2vfe014pQApBwXbR-DSUZX66TA-GrY4W4Q75s0h4xQKAv0HpXY6KeTBQqgEgQKYCXkQkXFLt6uzNNBIEpljAc'
          )
        };

        return registration.pushManager.subscribe(subscribeOptions);
      })
      .then(function(pushSubscription) {
        console.log('Received PushSubscription: ', JSON.stringify(pushSubscription));
        return pushSubscription;
      });
    },
    
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function displayConfirmNotification() {
  //new Notification('Powiadomienia włączone');
  if ('serviceWorker' in navigator) {
    var options = {
      body: 'Serwis powiadomień uruchomiony',
      icon: '/img/icons/apple-touch-icon-60x60.png',
      badge: '/img/icons/apple-touch-icon-60x60.png'
    };
    navigator.serviceWorker.ready
    .then(function(swreg) {
      swreg.showNotification('Sukces!', options);
    })
  } else {
    console.log('nie ma sw');
  }
}

//BA2vfe014pQApBwXbR-DSUZX66TA-GrY4W4Q75s0h4xQKAv0HpXY6KeTBQqgEgQKYCXkQkXFLt6uzNNBIEpljAc
//5ECueNonFIVSGbopbFevuhDQ0L7SdyW4rtcNVmENiyM

//https://web-push-codelab.glitch.me/

//https://web-push-book.gauntface.com/chapter-02/01-subscribing-a-user/
//https://developers.google.com/web/fundamentals/push-notifications/subscribing-a-user
//https://github.com/web-push-libs/web-push-php
</script>

<style>

</style>

          